// src/amplifyConfig.ts
import { Amplify } from 'aws-amplify';
import awsExports from './aws-exports';

// Configure Amplify with secure defaults and custom prefix
export const configureAmplify = () => {
  // Create a modified config with custom storage prefixes

  // Get the redirect URL from the current location if it exists
  const urlParams = new URLSearchParams(window.location.search);
  const redirectParam = urlParams.get('redirect');

  if (redirectParam) {
    localStorage.setItem('authRedirectUrl', redirectParam);
  }

  const customizedConfig = {
    ...awsExports,
    oauth: {
      ...awsExports.oauth,
      // You can optionally override these if needed
      redirectSignIn: `${window.location.origin}/auth/callback/`,
      redirectSignOut: window.location.origin,
      responseType: 'code', // Authorization code grant
      // Include any query parameters you need to preserve
      state: redirectParam ? btoa(JSON.stringify({ redirectUrl: redirectParam })) : undefined
    },
    Storage: {
      AWSS3: {
        bucket: awsExports.aws_user_files_s3_bucket,
        region: awsExports.aws_user_files_s3_bucket_region,
        customPrefix: {
          public: '',
          protected: '',
          private: ''
        }
      }
    },
    Auth: {
      OAuth: {
        domain: "auth.banjara-app.com",
        scope: awsExports.oauth.scope,
        redirectSignIn: `${window.location.origin}/auth/callback/`,
        redirectSignOut: window.location.origin,
        responseType: 'code'
      },
      // This is the key setting to enable hosted UI
      Cognito: {
        signInConfig: {
          isHostedUISignIn: true
        }
      }
    }

  };

  // Configure with the customized configuration
  Amplify.configure(customizedConfig);
    
};

export default awsExports;